<template>
  <div class="px-4">
    <Preparing v-if="isPreparing" />

    <div v-if="!isPreparing" class="container-fluid">
      <div class="d-flex justify-content-start align-items-start">
        <div class="col-lg-6 dashboard-heading mb-5 ml-3">
          <h3 class="fs-30 f900 dark-green-title">پروژه ها</h3>
        </div>
        <div class="col-lg-6 d-none d-lg-block dashboard-heading mb-5 ml-3">
          <h3 class="fs-30 f900 light-blue-title">دوره ها</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 d-flex flex-column flex-md-row align-items-start align-items-lg-stretch">
          <div class="col-lg-6 card-custom card-item mr-4">
            <div class="card-body d-flex align-items-start justify-content-around flex-column pt-4 px-2">
              <img width="100" height="130" style="object-fit: cover !important" src="../assets/images/project.png"
                class="mb-4" />
              <p class="black-text fs-20 font-weight-bold dark-blue-title mb-4">
                تمام پروژه ها
              </p>
              <p class="black-text fs-28 green-title">
                {{
                  formatPrice(
                    reports.PaperAccept + reports.PaperDone + reports.PaperDoing
                  )
                }}
              </p>
            </div>
          </div>
          <div class="col-lg-6 mr-4 px-0">
            <div class="d-flex">
              <div class="col-lg-6 pl-0 mb-5 mb-lg-0">
                <div style="height: 120px !important"
                  class="card-custom card-body card-item d-flex align-items-center justify-content-center flex-column mb-2">
                  <p class="black-text fs-6 font-weight-bold dark-blue-title mb-2">
                    در حال انجام
                  </p>
                  <p class="black-text fs-22 green-title">
                    {{ formatPrice(reports.PaperDoing) }}
                  </p>
                </div>
              </div>
              <div class="col-lg-6 pl-0">
                <div style="height: 120px !important"
                  class="card-custom card-item d-flex align-items-center justify-content-center flex-column">
                  <p class="black-text fs-6 font-weight-bold dark-blue-title mb-2">
                    انجام شده
                  </p>
                  <p class="black-text fs-22 green-title">
                    {{ formatPrice(reports.PaperDone) }}
                  </p>
                </div>
              </div>
            </div>
            <div class="d-flex">
              <div class="col-lg-6 pl-0">
                <div style="height: 120px !important"
                  class="card-custom card-item d-flex align-items-center justify-content-center flex-column">
                  <p class="black-text fs-10 font-weight-bold dark-blue-title mb-2">
                    درآمد از پروژه
                  </p>
                  <p class="black-text fs-16 green-title">
                    {{ formatPrice(reports.IncomePaper) }} تومان
                  </p>
                </div>
              </div>
              <div class="col-lg-6 pl-0">
                <div style="height: 120px !important"
                  class="card-custom card-item d-flex align-items-center justify-content-center flex-column">
                  <p class="black-text fs-6 font-weight-bold dark-blue-title mb-2">
                    پذیرش شده
                  </p>
                  <p class="black-text fs-22 green-title">
                    {{ formatPrice(reports.PaperAccept) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 d-lg-none d-block dashboard-heading mb-5 ml-3">
          <h3 class="fs-30 f900 light-blue-title">دوره ها</h3>
        </div>
        <div class="col-lg-6 col-12 d-flex align-items-start align-items-lg-stretch">
          <div class="col-lg-6 card-custom card-item mr-4">
            <div class="card-body d-flex align-items-start justify-content-around flex-column pt-4 px-2">
              <img width="100" height="130" style="object-fit: cover !important" src="../assets/images/video.png"
                class="mb-4" />
              <p class="black-text fs-20 font-weight-bold dark-blue-title mb-4">
                تمام دوره ها
              </p>
              <p class="black-text fs-28 light-blue-title">
                {{ formatPrice(reports.CourseAll) }}
              </p>
            </div>
          </div>
          <div class="col-lg-6 mr-4 px-0">
            <div class="d-flex">
              <div class="col-lg-6 pl-0 mb-5 mb-lg-0">
                <div style="height: 120px !important"
                  class="card-custom card-body card-item d-flex align-items-center justify-content-center flex-column mb-2">
                  <p class="black-text fs-6 font-weight-bold dark-blue-title mb-2">
                    دوره تایید شده
                  </p>
                  <p class="black-text fs-22 light-blue-title">
                    {{ formatPrice(reports.CourseAccept) }}
                  </p>
                </div>
              </div>
              <div class="col-lg-6 pl-0">
                <div style="height: 120px !important"
                  class="card-custom card-item d-flex align-items-center justify-content-center flex-column">
                  <p class="black-text fs-6 font-weight-bold dark-blue-title mb-2 px-1">
                    در انتظار تایید
                  </p>
                  <p class="black-text fs-22 light-blue-title">
                    {{ formatPrice(reports.CourseWait) }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-12 pl-0">
              <div style="height: 120px !important"
                class="card-custom card-item d-flex align-items-center justify-content-center flex-column">
                <p class="black-text fs-10 font-weight-bold dark-blue-title mb-2">
                  درآمد از دوره
                </p>
                <p class="black-text fs-16 light-blue-title">
                  {{ formatPrice(reports.IncomeCourse) }} تومان
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ls from "localstorage-slim";
import Preparing from "../components/Preparing.vue";
import axios from "axios";
export default {
  name: "DashBoard",
  components: { Preparing },
  beforeMount() {
    this.me = JSON.parse(ls.get("user"));

    this.getReports();
  },
  data() {
    return {
      isPreparing: true,
      me: {},
      reports: [],
    };
  },
  async created() {
    //await axios.get('user');
  },
  methods: {
    async getReports() {
      this.isPreparing = true;
      await axios
        .post("/api/v1/teacher/user/report", {
          uid: this.me.Uid,
        })
        .then((response) => {
          if (response.status === 200) {
            this.reports = response.data;
            this.isPreparing = false;
          }
        });
    },
  },
};
</script>
